<template>
    <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
    import * as echarts from 'echarts'
    require('echarts/theme/macarons') // echarts theme
    import resize from './mixins/resize'

    const animationDuration = 6000

    export default {
        mixins: [resize],
        props: {
            className: {
                type: String,
                default: 'chart'
            },
            width: {
                type: String,
                default: '100%'
            },
            height: {
                type: String,
                default: '300px'
            },
            chartDate: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                chart: null
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.initChart()
            })
        },
        watch: {
            chartDate: {
                handler(val) {
                    console.log('数据', val)
                    this.setOptions(val)
                }
            },
        },
        beforeDestroy() {
            if (!this.chart) {
                return
            }
            this.chart.dispose()
            this.chart = null
        },
        methods: {
            initChart() {
                this.chart = echarts.init(this.$el, 'macarons', { backgroundColor: 'transparent' })
                this.setOptions(this.chartDate)
            },
            setOptions({ data1, data2, xAxis } = {}) {
                this.chart.setOption({
                    legend: {
                        data: ['男', '女'],
                        orient: 'horizontal',
                        right: '1%', // 更靠近右侧
                        top: '3%', // 更靠近顶部
                        textStyle: {
                            color: '#fff',
                            fontSize: 14
                        },
                        icon: 'circle', // 图例的图标类型，可选值为 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
                        selected: {
                            '男': true, // 默认选中
                            '女': true // 默认选中
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: { // 坐标轴指示器，坐标轴触发有效
                            type: 'line' // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    backgroundColor: 'transparent',
                    grid: {
                        top: 10,
                        left: '0',
                        right: '0',
                        bottom: '3%',
                        containLabel: true,
                        backgroundColor: 'transparent' // 设置图表区域的背景色为透明
                    },

                    xAxis: [{
                        type: 'category',
                        data: xAxis,
                        axisTick: {
                            alignWithLabel: true
                        },

                        axisLabel: {
                            interval: 0,
                            fontSize: 11,
                            // rotate: 30,
                            color: '#fff', // 设置X轴文字颜色
                            formatter: function (value) {
                                // 自动换行逻辑：每 7 个字符换行一次
                                return value.match(/.{1,7}/g).join('\n');
                            }
                        },
                        // 设置 y 轴线的颜色
                        axisLine: {
                            lineStyle: {
                                color: '#4F7A9E' //
                            }
                        },


                    }],
                    yAxis: [{
                        type: 'value',
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#fff', // 设置字体颜色
                                fontSize: 12 // 设置字体大小为12
                            }
                        },
                        axisLine: {
                            show: false // 隐藏 Y 轴的轴线
                        },
                        splitLine: {
                            show: true, // 显示网格线
                            lineStyle: {
                                color: '#4F7A9E', // 设置网格线颜色为红色
                                type: 'solid', // 网格线类型，实线
                                width: 1 // 网格线宽度
                            }
                        }
                    }],
                    series: [{
                        name: '男',
                        type: 'bar',
                        // barCategoryGap: '70%',
                        // stack: 'vistors',
                        barWidth: '20px',
                        data: data1,
                        animationDuration,
                        barGap: '0%', // 设置同一类目下不同系列的柱子之间的间隙为0
                        barCategoryGap: '0%', // 设置不同类目之间的间隙为0
                        itemStyle: {
                            // 设置柱子的颜色
                            color: '#58BCFF', // 
                            borderRadius: [5, 5, 0, 0]
                        }
                    },
                    {
                        name: '女',
                        type: 'bar',
                        // barCategoryGap: '70%',
                        // stack: 'vistors',
                        barWidth: '20px',
                        data: data2,
                        animationDuration,
                        barGap: '0%', // 设置同一类目下不同系列的柱子之间的间隙为0
                        barCategoryGap: '0%', // 设置不同类目之间的间隙为0
                        itemStyle: {
                            // 设置柱子的颜色
                            color: '#FFA1A1', // 
                            borderRadius: [5, 5, 0, 0]
                        }
                    }
                    ]
                }, true)
            },
        }
    }
</script>